import React, { useState } from "react";
import { Button, Popover, Tooltip, Space } from "antd";
import {
  TbRectangle,
  TbOvalVertical,
  TbCircle,
  TbArrowUpRight,
  TbScribble,
} from "react-icons/tb";

const ACTIVE_COLOR = "#5dade2";
const DRAWING_COLOR = "#f5222d";

export const ANNOTATION_SHAPES = [
  { key: "rectangle", label: "Rectangle", Icon: TbRectangle },
  { key: "ellipse", label: "Ellipse", Icon: TbOvalVertical },
  { key: "circle", label: "Cercle", Icon: TbCircle },
  { key: "arrow", label: "Flèche", Icon: TbArrowUpRight },
  { key: "freehand", label: "Main levée", Icon: TbScribble },
];

const getShape = (key) =>
  ANNOTATION_SHAPES.find((s) => s.key === key) || ANNOTATION_SHAPES[0];

const AnnotationToolPicker = ({
  activeShape = "rectangle",
  isDrawing = false,
  onPick,
  disabled = false,
  placement = "right",
  className,
  buttonClassName,
  excludeShapes = [],
}) => {
  const [open, setOpen] = useState(false);
  const ActiveIcon = getShape(activeShape).Icon;
  const shapes = ANNOTATION_SHAPES.filter((s) => !excludeShapes.includes(s.key));

  const handlePick = (shapeKey) => {
    setOpen(false);
    if (onPick) onPick(shapeKey);
  };

  const content = (
    <Space size={4}>
      {shapes.map(({ key, label, Icon }) => {
        const isActiveShape = key === activeShape;
        const highlighted = isActiveShape && isDrawing;
        return (
          <Tooltip key={key} title={label} placement="bottom">
            <Button
              type={highlighted ? "primary" : "default"}
              shape="circle"
              size="middle"
              icon={<Icon />}
              onClick={() => handlePick(key)}
              style={{
                backgroundColor: highlighted ? DRAWING_COLOR : undefined,
                borderColor: isActiveShape && !highlighted ? ACTIVE_COLOR : undefined,
              }}
            />
          </Tooltip>
        );
      })}
    </Space>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={disabled ? false : open}
      onOpenChange={setOpen}
      placement={placement}
      destroyTooltipOnHide
    >
      <Tooltip title={open || disabled ? "" : "Annotations"} placement={placement}>
        <Button
          type="primary"
          shape="circle"
          size="middle"
          className={[buttonClassName, className].filter(Boolean).join(" ")}
          icon={<ActiveIcon />}
          disabled={disabled}
          style={{
            backgroundColor: isDrawing ? DRAWING_COLOR : undefined,
          }}
        />
      </Tooltip>
    </Popover>
  );
};

export default AnnotationToolPicker;
